import { createContext, useContext, useEffect, useState } from "react";

export type DeviceSize = "mobile" | "tablet" | "desktop";

const getDeviceSize = (): DeviceSize => {
  const width =
    window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if (width < 768) {
    return "mobile";
  }

  if (width < 1024) {
    return "tablet";
  }

  return "desktop";
};

const ResponsiveContext = createContext<DeviceSize>("mobile");

export const ResponsiveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [size, setSize] = useState<DeviceSize>(getDeviceSize);

  useEffect(() => {
    const handleResize = () => {
      setSize(getDeviceSize());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return <ResponsiveContext.Provider value={size}>{children}</ResponsiveContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export const useResponsive = (): DeviceSize => {
  return useContext(ResponsiveContext);
};
